// @flow
import type { InstitutionAddress } from '../../types/institution';

type State = {
  homeLocation: {},
  homeLocationLoading: boolean,
  homeLocationDidRequest: boolean,
  homeLocationError: string,
  homeLocationInstitutions: InstitutionAddress[],
  homeLocationInstitutionsLoading: boolean,
  currentLocation: {},
  currentLocationInstitutions: InstitutionAddress[],
  currentLocationLoading: boolean,
  currentLocationInstitutionsLoading: boolean,
  locationAccessRequested: boolean,
  locationAccessGranted: boolean
}

const initialState: State = {
  homeLocation: null,
  homeLocationLoading: false,
  homeLocationDidRequest: false,
  homeLocationError: null,
  homeLocationInstitutions: [],
  currentLocation: null,
  currentLocationLoading: false,
  currentLocationInstitutions: [],
  locationAccessRequested: false,
  locationAccessDenied: false
};

type Action = {
  type: string,
  [string]: any
}

const location = (state: State = initialState, action: Action): State => {
  switch (action.type) {
  // async
  case 'GET_HOME_LOCATION_REQUEST':
    return {
      ...state,
      homeLocationLoading: true
    };
  case 'GET_HOME_LOCATION_SUCCESS':
    return {
      ...state,
      homeLocationLoading: false,
      homeLocation: action.location
    };
  case 'GET_HOME_LOCATION_ERROR':
    return {
      ...state,
      homeLocationLoading: false,
      homeLocationError: action.error
    };
  case 'GET_HOME_LOCATION_INSTITUTIONS_REQUEST':
    return {
      ...state,
      homeLocationInstitutionsLoading: true
    };
  case 'GET_HOME_LOCATION_INSTITUTIONS_SUCCESS':
    return {
      ...state,
      homeLocationInstitutionsLoading: false,
      homeLocationInstitutions: action.institutions
    };

  case 'GET_HOME_LOCATION_INSTITUTIONS_ERROR':
    return {
      ...state,
      homeLocationInstitutionsLoading: false,
      homeLocationInstitutionsError: action.error
    };
  case 'CURRENT_LOCATION_REQUEST':
    return {
      ...state,
      currentLocationLoading: true
    };
  case 'CURRENT_LOCATION_SUCCESS':
    return {
      ...state,
      currentLocation: action.location,
      currentLocationLoading: false
    };
  case 'CURRENT_LOCATION_ACCESS_DENIED':
    return {
      ...state,
      currentLocationLoading: false,
      currentLocationDenied: true
    };
  case 'CURRENT_LOCATION_ERROR':
    return {
      ...state,
      currentLocationLoading: false,
      currentLocationError: action.error
    };
  case 'GET_CURRENT_LOCATION_INSTITUTIONS_REQUEST':
    return {
      ...state,
      currentLocationInstitutionsLoading: true
    };
  case 'GET_CURRENT_LOCATION_INSTITUTIONS_SUCCESS':
    return {
      ...state,
      currentLocationInstitutionsLoading: false,
      currentLocationInstitutions: action.institutions
    };
  case 'GET_CURRENT_LOCATION_INSTITUTIONS_ERROR':
    return {
      ...state,
      currentLocationInstitutionsLoading: false,
      currentLocationInstitutionsError: action.error
    };
  default:
    return state;
  }
};

export default location;



// WEBPACK FOOTER //
// ./src/store/reducers/location.js